import { atom } from 'jotai';

export const refreshAtom = atom<number>(0);

export const isRefetchingAtom = atom<boolean>(false);
